import { Injectable } from '@angular/core';
import { screenSizes } from '@app/utilities/theme';

@Injectable({ providedIn: 'root' })
export class ScreenScrollService {
    private paneElement: HTMLElement | null = null;

    registerPane(element: HTMLElement): void {
        this.paneElement = element;
    }

    scrollTo(
        position: number,
        smooth: boolean = false,
        mobileOnly: boolean = false
    ): void {
        const isMobile = window.innerWidth < screenSizes.mobile;

        if (mobileOnly && !isMobile) {
            return; // Skip scrolling if not on mobile
        }

        if (this.paneElement) {
            this.paneElement.scrollTo({
                top: position,
                behavior: smooth ? 'smooth' : 'auto',
            });
        } else {
            console.warn('ScrollPaneService: pane element not registered.');
        }
    }

    getScrollPosition(): number {
        if (this.paneElement) {
            return this.paneElement.scrollTop;
        } else {
            console.warn('ScrollPaneService: pane element not registered.');
            return 0; // Default to 0 if no pane is registered
        }
    }

    getScrollablePane(): HTMLElement | null {
        return this.paneElement;
    }

    clear(): void {
        this.paneElement = null;
    }
}
